import { useSSRHook } from "ssr-hook";
import { useHead } from "../services/common";
import { Project } from "../../types";
import Icon from "@mdi/react";
import { mdiCalendarMonth, mdiChevronDoubleRight, mdiPlus } from "@mdi/js";
import { Loading } from "../components";
import { useUser } from "../User";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { Link, useRouter } from "easy-page-router/react";
import { api } from "../services/api";
import { groupBy } from "lodash";

export default function Projects() {
    const { push, searchParams } = useRouter();

    useHead({
        title: "Naše projekty | T.J. Sokol Poniklá",
        description: "Informace o současných a minulých projektech T.J. Sokol Poniklá zaměřených na rozvoj sportovišť, podporu komunitního života a další iniciativy."
    });

    const user = useUser();

    const [projects, error, isLoading, reload] = useSSRHook<Project[]>("/api/projects");

    const [year, setYear] = useState(searchParams.year);

    const showProjects = (projects || []).filter(event => moment(event.date).format("YYYY") === year);

    useEffect(() => {
        if (projects && projects.length > 0 && !searchParams.year) {
            const last = Math.max(...projects.map(project => moment(project.date).year()));
            setYear(last.toFixed(0));
        }
    }, [projects]);

    async function handleAddProject() {
        const [projectId] = await api.addProject({});
        if (projectId) {
            push(`/projekt/${projectId}`);
        } else {
            // TODO: error
        }
    }

    return <>
        <div className="header">
            <h1>Projekty</h1>
        </div>
        <section className="width-max page-split">
            <div>
                {user.isAdmin && <div className="admin">
                    <button onClick={handleAddProject}><Icon path={mdiPlus} size={1} /> Přidat projekt</button>
                </div>}

                {isLoading && <Loading />}
                {error && <p className="alert">Projekty se nepodařilo načíst. Zkuste to prosím později.</p>}
                {projects && <>
                    {showProjects.length === 0 && <p className="info">Zatím zde nejsou žádné projekty.</p>}

                    {showProjects.length > 0 && <div className="project-list">
                        {showProjects.map(project => <ProjectPreview key={project._id} project={project} />)}
                    </div>}
                </>}
            </div>
            <ProjectYearList year={year} onChange={setYear} />
        </section>
    </>;
}

function ProjectPreview({ project }: { project: Project }) {
    return <Link className="item box" href={`/projekt/${project._id}`}>
        <h2><Icon path={mdiChevronDoubleRight} size={1} />{project.title}</h2>
        <div className="date"><Icon path={mdiCalendarMonth} size={0.8} />{moment(project.date).format("LL")}</div>
    </Link>;
}

export function ProjectYearList({ year, onChange }: { year?: string, onChange: (year: string) => void }) {
    const [projects, error, isLoading, reload] = useSSRHook<Project[]>("/api/projects");

    const years = useMemo(() => {
        if (!projects || projects.length < 1) return [{ year: moment().format("YYYY"), count: 0 }];

        const grouped = groupBy(projects, project => moment(project.date).format("YYYY"));

        return Object.entries(grouped).map(([year, p]) => ({
            year,
            count: p.length,
        }))
            .sort((a, b) => b.year.localeCompare(a.year));

    }, [projects]);

    return <ul>
        {years.map(y => <li key={y.year} className={y.year === year ? "active" : ""} onClick={() => onChange(y.year)}>
            <Icon path={mdiChevronDoubleRight} size={1} />
            {y.year}
            <div className="grow-1" />
            ({y.count})
        </li>)}
    </ul>
}